import apiClient from './apiClient'
import { getIdOrNull } from '..'

const ROOT = 'aphm/anomalies'

/** @enum {string} */
export const SerializationContexts = Object.freeze({
  INTERNSHIP: 'internship',
  DUPLICATE_OF: 'duplicateof',
  STUDENT: 'student',
  SECTOR: 'sector',
  INSTITUTION: 'institution',
  SNAPSHOT: 'snapshot',
  HANDLED_BY: 'handledby'
})

export const DETAIL_CONTEXTS = [
  SerializationContexts.INTERNSHIP,
  SerializationContexts.DUPLICATE_OF,
  SerializationContexts.STUDENT,
  SerializationContexts.SECTOR,
  SerializationContexts.SNAPSHOT,
  SerializationContexts.HANDLED_BY
]

export const getAllAphmAnomalies = (user, parameters = {}) => apiClient.get(user, ROOT, parameters)

export const getAphmAnomaly = (user, anomaly, contexts = DETAIL_CONTEXTS) =>
  apiClient.get(user, `${ROOT}/${getIdOrNull(anomaly)}`, { contexts })

export const getAphmAnomaliesSummary = (user) => apiClient.get(user, `${ROOT}/summary`)

/** @param {{status: string, comment?: string}} body */
export const handleAphmAnomaly = (user, anomaly, body) => apiClient.patch(user, `${ROOT}/${getIdOrNull(anomaly)}`, body)
